module.exports = __webpack_public_path__ + "media/images/noticia04-3-8edb1c2e4995690e6667ccf9b3b55f7b.jpeg";